module.exports = __webpack_public_path__ + "static/about_authors_art@2x-3d074cbd128e289d223716aa90243b0f.png";